import { createTheme } from "@material-ui/core/styles";
import { colors } from "../shared/utils";

const theme = createTheme({
  palette: {
    primary: {
      main: colors.blueDarken,
    },
  },
  props: {
    /*  MuiButton: {
      variant: "contained",
      color: "primary",
    }, */
    MuiTextField: {
      variant: "outlined",
      size: "small",
    },
  },
  overrides: {
    MuiInputLabel: {
      root: {
        marginLeft: "16px",
        marginBottom: "6px",
        color: colors.blueDarken,
        fontSize: ".82rem",
      },
    },
    MuiTextField: {
      root: {
        "& .MuiOutlinedInput-root": {
          "& fieldset": {
            borderRadius: "19px",
          },
          "&.MuiInputBase-root": { borderRadius: "19px" },
          "&.Mui-focused fieldset": {
            borderWidth: "1px",
          },
          "& input": { fontSize: ".75rem" },
          "& .MuiSelect-root": { fontSize: ".75rem", padding: "8.2px" },
          "& .MuiSelect-select:focus": { borderRadius: "19px" },
        },
      },
    },
    MuiPaper: {
      root: {
        "&.MuiPaper-root": {
          borderRadius: "19px",
        },
      },
    },

    MuiPickersToolbar: {
      toolbar: {
        backgroundColor: colors.blueLighten,
      },
    },
    MuiPickersYear: {
      yearSelected: {
        color: colors.blueLighten,
      },
    },
    MuiPickersDay: {
      daySelected: {
        backgroundColor: colors.blueLighten,
      },
    },
    MuiButton: {
      contained: {
        borderRadius: "20px",
      },
      textPrimary: {
        color: colors.blueLighten,
      },
    },
  },
});

export default theme;
